// schema
import * as ISchema from "#webapp/src/__schema__";
// libraries
import React from "react";

// components
import { TeamSections } from "../web-settings";

import { TeamSettingsAdminSlack } from "#webapp/src/components/teams-settings/team-settings-admin-form/team-settings-admin-slack";

// material-ui
import { Typography } from "@clockwise/design-system";
import { makeStyles } from "@material-ui/styles";

// ~-~-~-~-~-~-~-
// Team Slack Settings
// ~-~-~-~-~-~-~-
interface TeamSlackProps {
  org: ISchema.IOrg;
  team: ISchema.ITeam;
}

const useStyles = makeStyles({
  content: {
    marginBottom: 30,
  },
});

export const TeamSlack = (props: TeamSlackProps) => {
  const classes = useStyles();

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  const { org, team } = props;

  return (
    <div cw-id={`web-settings-${TeamSections.Slack}`} className={classes.content}>
      <Typography variant="h3" className="cw-mb-4">
        Connect team availability calendar with Slack?
      </Typography>
      <Typography variant="subtitle1" className="cw-mb-6">
        Clockwise can send a daily summary of events on the team availability calendar to your
        selected Slack channel.
      </Typography>
      <TeamSettingsAdminSlack org={org} team={team} isWebSettings />
    </div>
  );
};
